export async function logErrorToNewRelic(err: Error): Promise<void> {
  try {
    let error: Error

    if (err instanceof Error) {
      error = err
    } else {
      error = new Error(String(err))
    }

    const response = await fetch('/api/log-error', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        error: error.message,
      }),
    })

    if (!response.ok) {
      console.error('Failed to log error to New Relic:', response.status, response.statusText)
    }
  } catch (fetchError) {
    console.error('Failed to send error to logging API:', fetchError)
  }
}
